export const onLazyImportError = (error) => {
  if (error?.name === 'ChunkLoadError') {
    window.location.reload();
  }
  throw error;
};
